// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"WorkspacesList_listContainer__1JBrH","avatar":"WorkspacesList_avatar__Lha6w"};